export default __webpack_public_path__ + "static/media/lien-yc.f9c43476.png";